import React from 'react';
import { styled } from "../../../stitches.config";
import { observer } from 'mobx-react'
import HtmlParser from '../../../components/Article/Content/HtmlParser'

import { useStores } from '../../../helpers/useStores'

import lemonLeft from "./assets/lemon-left.png"
import lemonRight from "./assets/lemon-right.png"

import "animate.css/animate.min.css";
import { AnimationOnScroll } from 'react-animation-on-scroll';


const ParagraphIssue4282 = observer(({ paragraph }) => {
    const { text } = paragraph;
    const { ArticleStore } = useStores();

    return (
        <Wrapper>
            <AnimationOnScroll duration="3" animateOnce={true} animateIn="animate__fadeInLeftBig">
                <ImageLeft />
            </AnimationOnScroll>
            <WrapperPraser>
                <HtmlParser data={text} disableNofollow={ArticleStore.article.disableNofollowExtra} />
            </WrapperPraser>
            <AnimationOnScroll duration="3" animateOnce={true} animateIn="animate__fadeInRightBig">
                <ImageRight />
            </AnimationOnScroll>
        </Wrapper>
    )
})

const Wrapper = styled("div", {
    margin: "20px 38px",
    color: "$grayscale100Fixed",
    fontSize: "16px",
    fontWeight: 400,
    fontFamily: "$charis",
    position: "relative",
    display: "flex",
    justifyContent: "center",
    alignItems: "center",
    "a": {
        color: "rgb(255, 102, 0) !important",
        "&:hover": {
            textDecoration: "none"
        }
    },
    "@bp4": {
        margin: "20px auto",
        fontSize: "21px",
        letterSpacing: 0,
        lineHeight: 32
    }
});

const WrapperPraser = styled("div", {
    "@bp4": {
        width: "840px",
        margin: "0 20px",
        flexShrink: "0"
    }
});

const ImageLeft = styled("div", {
    width: "285px",
    height: "235px",
    backgroundImage: `url("${lemonLeft}")`,
    backgroundPosition: "center",
    backgroundSize: "cover",
    display: "none",
    "@media (min-width: 1450px)": {
        display: "block"
    }
});

const ImageRight = styled("div", {
    width: "285px",
    height: "235px",
    backgroundImage: `url("${lemonRight}")`,
    backgroundPosition: "center",
    backgroundSize: "cover",
    display: "none",
    "@media (min-width: 1450px)": {
        display: "block"
    }
});

export default ParagraphIssue4282;